<template>
    <table class="table table-condensed table-striped">
        <thead>
            <tr>
                <th class="col-xs-4 text-center">
                    <input type="checkbox" @click="toggle">
                </th>

                <th class="col-xs-20">
                    {{ optionLabel }}
                </th>
            </tr>
        </thead>

        <tbody>
            <tr v-for="option in options">
                <td class="text-center">
                    <input
                            type="checkbox"
                            :name="name"
                            :value="option.value"
                            :checked="value.indexOf(option.value) > -1"
                            :disabled="disabled"
                            @click.stop="emit(option.value)"
                    ></td>

                <td>
                    {{ option.label }}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        props: {
            "name": {},
            "value": {},
            "options": {},
            "error": {},
            "disabled": {"default": false},
            optionLabel: {}
        },

        methods: {
            toggle(e) {
                if (e.target.checked) {
                    return this.$emit('input', this.options.map(option => option.value))
                }

                this.$emit("input", []);
            },

            emit(value) {
                let newValue = this.value;

                if (this.value.indexOf(value) > -1) {
                    newValue.splice(this.value.indexOf(value), 1);
                } else {
                    newValue.push(value);
                }

                this.$emit("input", newValue);
            }
        }
    }
</script>
